import VueI18n  from 'vue-i18n';
import Vue from 'vue'
import { DEFAULT_LANGUAGE, FALLBACK_LANGUAGE } from 'constants/trans'
import en from 'langs/en.json'

Vue.use(VueI18n);


const messages = {
  en,
};

const i18n = new VueI18n({
  locale: DEFAULT_LANGUAGE,
  fallbackLocale: FALLBACK_LANGUAGE,
  messages
})


i18n.watchI18nData();
i18n.watchI18nData = () => {};

export default i18n;